export var AlgoliaEnv;
(function (AlgoliaEnv) {
    AlgoliaEnv["DEVELOPMENT"] = "dev";
    AlgoliaEnv["LOCAL"] = "local";
    AlgoliaEnv["PRODUCTION"] = "prod";
})(AlgoliaEnv || (AlgoliaEnv = {}));
export var SentryEnvironment;
(function (SentryEnvironment) {
    SentryEnvironment["LOCAL"] = "local";
    SentryEnvironment["PROD"] = "prod";
    SentryEnvironment["DEV"] = "dev";
    SentryEnvironment["PREVIEW_CHANNEL"] = "previewChannel";
})(SentryEnvironment || (SentryEnvironment = {}));
export var FeatureFlag;
(function (FeatureFlag) {
    FeatureFlag["CALL_TIME_SLOT_TRIGGER"] = "callTimeSlotTrigger";
    FeatureFlag["CANCEL_VISIT_DRY_RUN"] = "cancelVisitDryRun";
    FeatureFlag["COMPLETE_TRANSACTIONS"] = "completeTransactions";
    FeatureFlag["DEBUG"] = "debug";
    /** Disable automatic requisition form faxing */
    FeatureFlag["DISABLE_AUTO_FAX_REQ_FORMS"] = "disableAutoFaxReqForms";
    /**
     * Disable the creation of a shopify order when generating a sample shipment
     * for a booking
     */
    FeatureFlag["DISABLE_BOOKING_SHOPIFY_ORDER_CREATION"] = "disableBookingShopifyOrderCreation";
    /** Disable the creation of a draft waypoint from a draft order */
    FeatureFlag["DISABLE_DRAFT_WAYPOINT_SCHEDULING"] = "disableDraftWaypointScheduling";
    FeatureFlag["DISABLE_GENERATION_OF_PROCESSING_ACTIONS"] = "disableGenerationOfProcessingActions";
    FeatureFlag["DISABLE_IN_OFFICE_SUPPORT"] = "disableInOfficeSupport";
    FeatureFlag["DISABLE_OFFICE_LAB_RESULTS_SETTINGS"] = "disableOfficeLabResultsSettings";
    FeatureFlag["DISABLE_OFFICE_ORDER_SETTINGS"] = "disableOfficeOrderSettings";
    /**
     * Disable appointing another user to provide an order during order creation
     * flow
     */
    FeatureFlag["DISABLE_ORDER_APPOINTMENT"] = "disableOrderAppointment";
    FeatureFlag["DISABLE_ORDER_SPLITTING"] = "disableOrderSplitting";
    FeatureFlag["DISABLE_PATIENT_VISIT_SUPPLY_SCANNING"] = "disablePatientVisitSupplyScanning";
    FeatureFlag["DISABLE_SHIFT_SUPPLY_PREPARATION"] = "disableShiftSupplyPreparation";
    FeatureFlag["DISABLE_WAYPOINT_TRANSIT_STATUS_BLOCKING"] = "disableWaypointTransitStatusBlocking";
    /**
     * Enable additional logging in `fetchWithRelationships` in apps. Recommended
     * for temporary local overrides and not for use globally in production as it
     * could impact performance.
     */
    FeatureFlag["FRONTEND_VERBOSE_FWR"] = "frontendVerboseFWR";
    FeatureFlag["IS_HEALTH_GORILLA_LIVE"] = "isHealthGorillaLive";
    FeatureFlag["LAB_INFO_FORM_BOOKING"] = "labInfoFormBooking";
    FeatureFlag["NURSE_ORDER_KIT"] = "nurseOrderKit";
    /** If set to false, Hide visits page on office app. */
    FeatureFlag["OFFICE_VISITS_PAGE"] = "officeVisitsPage";
    FeatureFlag["PATIENT_INITIATED_BOOKING"] = "patientInitiatedBooking";
    FeatureFlag["PATIENT_PAYMENTS"] = "patientPayments";
    FeatureFlag["PRESCRIBER_BOOKING_FLOW_MULTIPLE_PROCEDURES"] = "prescriberBookingFlowMultipleProcedures";
    FeatureFlag["PRESCRIBER_WAYPOINT_CREATION"] = "prescriberWaypointCreation";
    FeatureFlag["PRIVATE_LABS"] = "privateLabs";
    /**
     * For use during development or testing to test the scheduling flow
     * repeatedly on the same draft waypoint. Skips calling cloud functions
     * during the confirmVisit action at the end of the scheduling flow. Do not
     * set to true in the database - only in local feature flag overrides.
     */
    FeatureFlag["SCHEDULING_FLOW_DRY_RUN"] = "schedulingFlowDryRun";
    /**
     * Disable automatic generation of supply transfers on finalized draft
     * waypoints
     */
    FeatureFlag["SUPPLY_TRANSFERS_DISABLED"] = "supplyTransfersDisabled";
    /**
     * Disable showing the date a pending transaction is withdrawable in the
     * nurse wallet
     */
    FeatureFlag["WITHDRAWABLE_BALANCE_DISABLED"] = "withdrawableBalanceDisabled";
})(FeatureFlag || (FeatureFlag = {}));
/**
 * Enum for testing hot module replacement for both output values (`.js`), and
 * type definitions (`.d.ts`)
 *
 * Example tests:
 * - Change the string value of VALUE_ONE and observe if it updates in app/storybook.
 * - Change the name of TestEnum and watch for type errors in app/storybook.
 */
export var TestEnum;
(function (TestEnum) {
    TestEnum["VALUE_ONE"] = "valueOne";
    TestEnum["VALUE_TWO"] = "valueTwo";
})(TestEnum || (TestEnum = {}));
//# sourceMappingURL=environment.js.map